import { useDialogPolyfill } from "@wss/dialog";
import ct from "class-types.macro";
import React, { DialogHTMLAttributes, FC, ReactElement } from "react";
import Icon from "~/common/Icons/Standard";
if (window.HTMLDialogElement === undefined) import("dialog-polyfill/dialog-polyfill.css");
type ModalProps = DialogHTMLAttributes<HTMLDialogElement> & {
  modalRef: React.RefObject<HTMLDialogElement>;
  className?: string;
  headerTitle: string;
  titleClasses?: string;
  headerStyles?: React.CSSProperties;
  footer?: boolean;
  footerClasses?: string;
  footerContent?: ReactElement;
  addMainPadding?: boolean;
  closeModal?: () => void;
};
const DialogModal: FC<ModalProps> = ({
  children,
  className = "",
  modalRef,
  headerTitle,
  titleClasses,
  headerStyles,
  footer,
  footerClasses,
  footerContent,
  style,
  addMainPadding = true,
  closeModal,
  ...rest
}) => {
  useDialogPolyfill(modalRef);
  const handleClose = () => {
    if (closeModal) {
      closeModal();
      return;
    }
    modalRef.current?.close();
  };
  return <dialog data-testid="ribbon-dialog" ref={modalRef} className={`${ct("p-0", "fixed", "max-w-4xl", "bg-white", "border-gray-200", "rounded", "border-solid", "border", "opacity-100", "outline-none", "overflow-y-auto", "overflow-x-hidden", "inset-x-0", "shadow-lg", "w-11/12")} ${className}`} style={{
    zIndex: 1000,
    ...style
  }} aria-label={headerTitle} {...rest} data-sentry-component="DialogModal" data-sentry-source-file="DialogModal.tsx">
      <header style={{
      lineHeight: "29px",
      ...headerStyles
    }} className={ct("border-gray-200", "border-solid", "border-0", "border-b", "flex", "items-center", "px-6", "py-2")}>
        <div className={`font-bold text-lg ${titleClasses}`}>{headerTitle}</div>
        <button type="button" aria-label="Close" onClick={handleClose} className={ct("bg-transparent", "border-none", "cursor-pointer", "flex", "font-bold", "text-3xl", "mb-0", "ml-auto", "p-0")} style={{
        textShadow: "0 1px 0 #fff"
      }}>
          <Icon name="remix-close" className={ct("h-6", "fill-current", "text-gray-500", "w-6")} data-sentry-element="Icon" data-sentry-source-file="DialogModal.tsx" />
        </button>
      </header>
      <main className={`flex-1 text-lg leading-6 text-gray-800 border-t border-gray-600 ${addMainPadding ? "p-6 " : ""}`}>
        {children}
      </main>
      {footer && <footer className={footerClasses}>{footerContent}</footer>}
    </dialog>;
};
export default DialogModal;